import React, { useEffect, useState } from 'react';
import { Alert } from 'react-bootstrap';

import { JobTypeEnum } from '../../../common/spdCore/validation/schemas';
import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { GetJobConfigDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import momencik from '../../../common/momencik';

interface JobConfigInfoItem {
  jobType: JobTypeEnum;
  nextStartLabel: string;
  frequencyLabel: string;
}

interface JobConfigInfoProps {
  items: JobConfigInfoItem[];
}

export const JobConfigInfo: React.FC<JobConfigInfoProps> = ({ items }) => {
  const pok = useSpdCore();
  const [jobConfigs, setJobConfigs] = useState<
    Map<JobTypeEnum, GetJobConfigDto>
  >(new Map());

  useEffect(() => {
    const fetchJobConfigs = async () => {
      const configs = new Map<JobTypeEnum, GetJobConfigDto>();

      for (const item of items) {
        try {
          const jobData = await pok.jobConfig.getByJobName(item.jobType);
          configs.set(item.jobType, jobData);
        } catch {
          // Ignore errors, just skip this config
        }
      }

      setJobConfigs(configs);
    };

    void fetchJobConfigs();
  }, [pok, items]);

  if (jobConfigs.size === 0) {
    return null;
  }

  return (
    <Alert variant="info" className="mb-3">
      {items.map((item, index) => {
        const jobConfig = jobConfigs.get(item.jobType);
        if (!jobConfig) {
          return null;
        }

        return (
          <React.Fragment key={index}>
            {jobConfig.nextStart && (
              <>
                <strong>{item.nextStartLabel}:</strong>{' '}
                {momencik(jobConfig.nextStart, 'YYYY-MM-DD HH:mm:ss')}
                <br />
              </>
            )}
            <strong>{item.frequencyLabel}:</strong>{' '}
            {jobConfig.croneDescription || jobConfig.crone}
            {index < items.length - 1 && (
              <>
                <br />
                <br />
              </>
            )}
          </React.Fragment>
        );
      })}
    </Alert>
  );
};
